<script>
  import IconButton from './components/IconButton.svelte';
  import { tick } from 'svelte';

  export let menus;
  export let openedMenu;

  function toggleMenu(menu) {
    if (openedMenu === menu) {
      openedMenu = null;
    } else {
      openedMenu = menu;
    }
  }

  let rail;
  // When a menu is opened, focus on the first button.
  $: if (openedMenu !== null) { (async () => {
    await tick();
    rail.parentNode.querySelector('aside.open button').focus();
  })() }
</script>

<div class="rail" bind:this={rail}>
  <img src="images/prr_logo_small.png" alt="Polar Rock Repository">
  <nav>
    {#each menus as menu}
      <div class="button">
        <IconButton
          name={menu.name}
          action={() => toggleMenu(menu.name)}
          selected={openedMenu === menu.name}
        >
          <div class="icon-contents">
            <svelte:component this={menu.icon}/>
            <div>
              {menu.name}
            </div>
          </div>
        </IconButton>
      </div>
    {/each}
  </nav>
</div>

<style>
  div.rail {
    z-index: 2;
    background: #495864;
    width: 85px;
    overflow: auto;
    box-shadow:
      2px 0 1px -1px rgba(0,0,0,.2),
      1px 0 1px  0   rgba(0,0,0,.14),
      1px 0 3px  0   rgba(0,0,0,.12);
  }

  div.button {
    margin-top: 2px;
    margin-bottom: 2px;
  }

  div.icon-contents {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  div.icon-contents > div {
    margin: 5px;
  }

  nav {
    display: flex;
    flex-direction: column;
    text-align: center;
    line-height: 1.22;
    text-decoration: none;
    font-size: 10pt;
    font-weight: 600;
    font-family: 'proximanova', 'Source Sans Pro', sans-serif;
    color: #fff;
    align-items: center;
  }

  nav :global(button) {
    margin: 0.25em 0;
  }

  img {
    width: 79px;
    height: 79px;
    margin: 3px;
  }

  @media (max-width: 36rem) {
    div.rail {
      position: absolute;
      width: 100%;
      box-shadow: none;
    }

    nav {
      flex-direction: row;
      width: max-content;
    }

    nav :global(button) {
      margin: 0 0.5em;
      filter:
        drop-shadow(0 0 0.125em black)
        drop-shadow(0 0 0.25em rgba(0, 0, 0, 0.5));
    }

    img {
      width: 0;
      height: 0;
      margin: 0;
    }

    div.button {
      margin-top: 0;
      margin-bottom: 0;
    }
  }
</style>
